module.exports = __webpack_public_path__ + "static/media/firefox.3b1f5de2.jfif";